export const getErrorState = (state) => state.errorState;